import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const saveOrUpdateAdminCoupon = createAsyncThunk(
  "adminCoupon/saveOrUpdate",
  async ({ code, description }) => {
    const response = await api.post("/admin-coupon/", { code, description });
    return response.data;
  }
);

// 2️⃣ Fetch the single admin coupon
export const fetchAdminCoupon = createAsyncThunk(
  "adminCoupon/fetch",
  async () => {
    const response = await api.get("/admin-coupon/");
    return response.data;
  }
);